import { DelaysAnalysisTableData } from '../../../../types/otpTypes';
import { TableDispatchAction, TableSortProperties } from '../../../../types/types';

export default function tableSortReducer(state: TableSortProperties<DelaysAnalysisTableData>, action: TableDispatchAction<DelaysAnalysisTableData>): TableSortProperties<DelaysAnalysisTableData> {
    switch (action.type) {
        case 'CHANGE_SORT': {
            if (state.column === action.column) {
                return {
                    ...state,
                    data: state.data.slice().reverse(),
                    direction: state.direction === 'ascending' ? 'descending' : 'ascending',
                };
            }
            let data = [];
            switch (action.column) {
                case 'vehicleId':
                case 'routeName':
                    data = state.data.sort((a, b) => {
                        const aVal = a[action.column] as string;
                        const bVal = b[action.column] as string;
                        if (aVal > bVal) {
                            return 1;
                        } else if (aVal < bVal) {
                            return -1;
                        }
                        return 0;
                    });
                    break;
                case 'tripSchedule':
                    data = state.data.sort((a, b) => new Date(a.tripScheduleStart).getTime() - new Date(b.tripScheduleStart).getTime());
                    break;
                case 'ourMeanDelayErrorSec':
                case 'siriMeanDelayErrorSec':
                case 'ourMaxDelayErrorSec':
                case 'siriMaxDelayErrorSec':
                    data = state.data.sort((a, b) => {
                        const aVal = a[action.column] as number | null;
                        const bVal = b[action.column] as number | null;
                        if (aVal === null)
                            return -1;
                        if (bVal === null)
                            return 1;
                        return aVal - bVal;
                    });
                    break;
                default:
                    data = state.data;
            }
            return {
                column: action.column,
                data: data,
                direction: 'ascending',
            };
        }
        case 'UPDATE_DATA': {
            return {
                ...state,
                data: action.data || [],
            };
        }
    }
}